// AUTO-GENERATED by scripts/set-env.js — do not edit by hand.
// Change values via environment variables or the .env file.
export const environment = {
  production: false,
  apiUrl: 'https://dev.tneb-flyash.bontonsoftwares.com/api/public/wsapi/',
  apiKey: 'APP_FLYASH_PUBLIC_2026',
  googleMapsApiKey: 'AIzaSyBgzF6BQVwhIEcPl-GeItVGVQbmmCyr1lk',
};
